module.exports = __webpack_public_path__ + "static/media/icon-check.b347ed6a.svg";